import { render, staticRenderFns } from "./CampaignData.vue?vue&type=template&id=3c81ebec&scoped=true"
import script from "./CampaignData.vue?vue&type=script&lang=js"
export * from "./CampaignData.vue?vue&type=script&lang=js"
import style0 from "./CampaignData.vue?vue&type=style&index=0&id=3c81ebec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81ebec",
  null
  
)

export default component.exports